/* * @Author: Wei Guojun * @Date: 2021-04-14 09:57:07 * @Last Modified by: Wei
Guojun * @Last Modified time: 2022-02-23 09:49:46 */
<template>
  <div class="abnormal">
    <section>
      <div class="title">
        共有
        <span>{{ count.abnormal_count || 0 }}</span> 个异常信息订单
      </div>
      <div class="table">
        <el-table
          border
          :index="indexMethod"
          :height="tableHeight"
          :data="tableData"
          style="width: 100%"
          size="mini"
          id="tableBox"
        >
          <el-table-column align="center" width="50" label="选择">
            <template slot-scope="scope">
              <el-checkbox
                :value="parcel_id_list.includes(scope.row.id)"
                @change="checkBox(scope.row.id)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="序号"
            width="50"
            type="index"
          ></el-table-column>
          <el-table-column align="center" label="收件人姓名">
            <template slot="header">
              <p>收件人姓名</p>
              <p class="errorHint">（不超过10个字）</p>
            </template>
            <template slot-scope="scope">
              <div :class="scope.row.receiver_name_result ? '' : 'error'">
                {{ scope.row.receiver_name || "必填" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="addressee_phone">
            <template slot="header">
              <p>收件人联系方式</p>
              <p class="errorHint">（手机号或座机号）</p>
            </template>
            <template slot-scope="scope">
              <div :class="scope.row.receiver_phone_result ? '' : 'error'">
                {{ scope.row.receiver_phone || "必填" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="addressee_address" label="收件人地址">
            <template slot="header">
              <p>收件人地址</p>
              <p class="errorHint">
                （详细地址不少于3个字、不超过54个字且是真实地址）
              </p>
            </template>
            <template slot-scope="scope">
              <div :class="scope.row.receiver_address_result ? '' : 'error'">
                {{
                  scope.row.receiver_address
                    ? scope.row.receiver_province +
                      " " +
                      scope.row.receiver_city +
                      " " +
                      scope.row.receiver_district +
                      " " +
                      scope.row.receiver_address
                    : "必填"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="sender_name">
            <template slot="header">
              <p>寄件人姓名</p>
              <p class="errorHint">（不超过10个字）</p>
            </template>
            <template slot-scope="scope">
              <div :class="scope.row.sender_name_result ? '' : 'error'">
                {{ scope.row.sender_name || "必填" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="sender_phone">
            <template slot="header">
              <p>寄件人联系方式</p>
              <p class="errorHint">（手机号或座机号）</p>
            </template>
            <template slot-scope="scope">
              <div :class="scope.row.sender_phone_result ? '' : 'error'">
                {{ scope.row.sender_phone || "必填" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sender_address" label="寄件人地址">
            <template slot="header">
              <p>寄件人地址</p>
              <p class="errorHint">
                （详细地址不少于3个字、不超过39个字且是真实地址）
              </p>
            </template>
            <template slot-scope="scope">
              <div :class="scope.row.sender_address_result ? '' : 'error'">
                {{
                  scope.row.sender_address
                    ? scope.row.sender_province +
                      " " +
                      scope.row.sender_city +
                      " " +
                      scope.row.sender_district +
                      " " +
                      scope.row.sender_address
                    : "必填"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template slot="header">
              <p>物品类型</p>
              <p class="errorHint">（不超过10个字）</p>
            </template>
            <template slot-scope="scope">
              <div :class="scope.row.item_type_result ? '' : 'error'">
                {{ scope.row.item_type || "必填" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="80" align="center" label="快递类型" v-if="yddserve">
            <template slot-scope="scope">
              <div>{{ scope.row.express_type | kdtype }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template slot="header">
              <p>重量</p>
              <p class="errorHint">（单位KG,最多两位小数）</p>
            </template>
            <template slot-scope="scope">
              <div :class="scope.row.goods_weight_result ? '' : 'error'">
                {{ scope.row.goods_weight || "必填" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template slot="header">
              <p>备注</p>
              <p class="errorHint">（不超过60个字）</p>
            </template>
            <template slot-scope="scope">
              <div :class="scope.row.item_note_result ? '' : 'error'">
                {{ scope.row.item_note }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="120" label="操作">
            <template slot-scope="scope">
              <div class="operation">
                <a @click="showDel(scope.row.id)" href="javascript:void(0)"
                  >删除</a
                >
                <a @click="edit(scope.row)" href="javascript:void(0)">编辑</a>
              </div>
            </template>
          </el-table-column>
          <div slot="empty" class="noBody">
            <img src="@/assets/images/nodata.png" alt />
          </div>
        </el-table>
      </div>
      <div class="pages">
        <div class="pages_left"></div>
        <div class="pages_right">
          <el-pagination
            v-if="showPage"
            prev-text="上一页"
            next-text="下一页"
            :page-size="page_size"
            @size-change="changeSizes"
            :page-sizes="[30, 50, 100, 200, 500]"
            @current-change="currentPage"
            :current-page.sync="currPage"
            layout="sizes,prev, pager, next, jumper"
            :total="table_total"
          ></el-pagination>
          <div slot="append" class="sure" type="primary">确定</div>
        </div>
      </div>
    </section>
    <footer>
      <div class="footer">
        <div>
          <div class="allCheck">
            <el-checkbox @change="allCheck" v-model="all">本页全选</el-checkbox>
            <span
              >已选<b>{{ parcel_id_list.length }}</b></span
            >
          </div>
          <div class="btn">
            <el-button type="info" class="footBtn" disabled
              >批量提交给快递员</el-button
            >
            <el-button type="info" class="footBtn" disabled>直接打印</el-button>
            <el-button type="info" class="footBtn" disabled
              >导入保存稍后打印</el-button
            >
            <el-button class="footBtn" type="primary" @click="batchDel()"
              >批量删除</el-button
            >
          </div>
        </div>
      </div>
    </footer>
    <el-dialog
      width="534px"
      height="208px"
      :visible.sync="tips"
      top="375px"
      center
    >
      <div class="content">
        还有
        <span>{{ count.abnormal_count }}个</span>异常信息订单，请修改后再导入
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tips = false">我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="534px"
      height="208px"
      top="375px"
      :visible.sync="isDel"
      center
    >
      <div class="content">
        确定
        <span>删除</span>已选订单信息？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDel = false">取 消</el-button>
        <el-button type="primary" @click="del">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="dialog"
      center
      top="50px"
      width="1300px"
      title="包裹信息预览"
      :visible.sync="dialog"
      @close="closeDialog"
    >
      <div style="height: 600px">
        <editSheet ref="editSheet" :itemData="itemData"></editSheet>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import editSheet from "@/components/editSheet";
import home from "@/api/home.js";
import util from "@/util/util";
import { mapGetters } from "vuex";
export default {
  name: "errorSheet",
  data() {
    return {
      tableHeight: 300,
      tableData: [],
      count: {
        abnormal_count: 0,
        normal_count: 0,
      },
      parcel_id_list: [],
      page_size: 30,
      currPage: 1, //当前页数
      table_total: 0, //总数
      showPage: true,
      all: false,
      tips: false,
      isDel: false, // 删除提示
      checked_id: 0,
      isPrint: false,
      isLoading: false,
      _qrcode: null,
      isNull: false,
      isUp: false,
      parcel_id_list: [],
      itemData: {},
      dialog: false,
      isAuth: false,
      yddserve:false,
    };
  },

  components: {
    editSheet,
  },

  created() {
    //创建时执行
  },
  computed: {
    ...mapGetters(["getFrom"]),
  },
  filters:{
    kdtype(data){
      var string = "";
      if (data == 'TK') {
        string = "智橙网";
      } else if (data == 'PK') {
        string = "普通快递";
      } else {
        string = "";
      }
      return string;
    },
  },
  mounted() {
    //是否开启智橙网服务
    const ydd_serve = util.getJsonValues(this.$store.state.commondict,'yousuda');
    if(ydd_serve){
      this.yddserve = true; 
    }
    this.loadData();
    util.getTableHeight(this, document.getElementById("tableBox"), 104);
    window.addEventListener("resize", () => {
      util.getTableHeight(this, document.getElementById("tableBox"), 104);
    });
  },
  destroyed() {
    window.removeEventListener("resize", () => {
      util.getTableHeight(this, document.getElementById("tableBox"), 104);
    });
  },
  methods: {
    //函数声明
    //函数声明
    closeDialog() {},
    /** 加载数据 */
    loadData() {
      let userset = JSON.parse(this.$store.state.userSet);
      this.page_size = userset.sizeNum || 30;
      this.parcel_id_list = [];
      this.all = false;
      home
        .getTempOrder(this, {
          wrong_page: this.currPage,
          wrong_size: this.page_size,
        })
        .then((res) => {
          if (res.success) {
            this.tableData = res.data.wrong_list;
            this.count.abnormal_count = res.data.wrong_num;
            this.count.normal_count = res.data.right_num;
            this.table_total = res.data.wrong_num;
            this.$store.state.wrongNum = this.table_total;
          }
        });
    },

    /** 显示删除框 */
    showDel(id) {
      this.isDel = true;
      this.checked_id = id;
    },
    del() {
      this.isDel = false;
      home.delTempOrder(this, this.checked_id).then((res) => {
        if (res.success) {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
          this.loadData(true);
        }
      });
    },

    /** 编辑 */
    edit(data) {
      this.itemData = Object.assign(this.itemData, data);
      this.dialog = true;
    },

    /** 改变条数 */
    changeSizes(e) {
      this.currPage = 1;
      this.page_size = e;
      let userset = JSON.parse(this.$store.state.userSet);
      userset.sizeNum = e;
      this.$store.commit("SET_USER_SET", JSON.stringify(userset));
      this.loadData(true);
      this.parcel_id_list = [];
    },
    /** 当前页 */
    currentPage(e) {
      this.currPage = e;
      this.loadData(true);
      this.parcel_id_list = [];
    },
    indexMethod(index) {
      return index + 1;
    },
    // 实名认证弹框返回授权结果
    realNameAuth(data) {
      console.log(data);
      // 授权成功
      if (data.auth) {
        this.name = data.info.name;
        this.number = data.info.cardNo;
        this.realname_id = data.info.realname_id;
        setTimeout(() => {
          this.saveParcels();
        }, 500);
      } else {
      }
    },

    // 网点用户导入保存
    netSave() {
      this.isAuth = true;
      setTimeout(() => {
        this.$refs.auth.dialog = true;
      }, 200);
    },
    // 网点导入保存包裹信息
    saveParcels() {
      this.$confirm(
        "共<span style='color:#ff0000'>" +
          this.count.normal_count +
          "</span>个订单信息，确认保存这些订单吗",
        "提示",
        {
          confirmButtonText: "确认导入",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.$showLoading();
          this.isPrint = false;
          this.isLoading = true;
          Net.saveNetTempParcel(this).then((res) => {
            if (res.success) {
              this.$hideLoading();
              this.$message({
                message: "导入成功",
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.$router.push("/net-pend/index");
                },
              });
            }
          });
        })
        .catch(() => {});
    },

    save() {
      // 确认是否实名
      this.$confirm(
        "共<span style='color:#ff0000'>" +
          this.count.normal_count +
          "</span>个订单信息，确认保存这些订单吗",
        "提示",
        {
          confirmButtonText: "确认导入",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.$showLoading();
          this.isPrint = true;
          this.isLoading = true;
          api.saveTempParcel(this).then((res) => {
            if (res.success) {
              this.$hideLoading();
              this.$message({
                message: "导入成功",
                type: "success",
                duration: 1000,
                onClose: () => {
                  api.getQrcode(this).then((res) => {
                    if (res.success) {
                      this.qrcode(res.data);
                    }
                  });
                },
              });
            }
          });
        })
        .catch(() => {});
    },
    /** 单选单个Box */
    checkBox(e) {
      let list = this.parcel_id_list;
      if (list.indexOf(e) != -1) {
        list.splice(
          list.findIndex((item) => item === e),
          1
        );
      } else {
        list.push(e);
      }
      if (list.length > 0 && list.length < this.tableData.length) {
        this.isAll = true;
        this.all = false;
      } else if (list.length == this.tableData.length) {
        this.isAll = false;
        this.all = true;
      } else {
        this.isAll = false;
        this.all = false;
      }
      this.parcel_id_list = list;
    },
    /** 全选 */
    allCheck(e) {
      let list = [];
      if (e) {
        this.tableData.forEach((item) => {
          list = [...list, item.id];
        });
        this.all = true;
      } else {
        this.all = false;
      }
      this.parcel_id_list = list;
    },
    batchDel() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要删除的包裹",
        });
        return;
      }
      this.$confirm(
        "已选<span style='color:#ff0000'>" +
          this.parcel_id_list.length +
          "</span>个包裹，确认删除已选包裹？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        home.delTempOrder(this, this.parcel_id_list.join(",")).then((res) => {
          if (res.success) {
            this.$message({
              message: "删除成功！",
              type: "success",
            });
            if (this.parcel_id_list.length == this.tableData.length) {
              if (this.currPage == 1) {
                this.currPage = 1;
              } else {
                this.currPage--;
              }
            }
            this.parcel_id_list = [];
            this.all = false;
            this.loadData(true);
          }
        });
      });
    },
    toPend() {
      this.isPrint = false;
      this.$router.push("/pend");
    },
    cancel() {
      this.$confirm(
        "确认取消本次导入操作吗？取消后将清除本次导入数据?",
        "提示",
        {
          confirmButtonText: "确认取消",
          cancelButtonText: "再考虑一下",
          type: "warning",
        }
      )
        .then(() => {
          localStorage.removeItem("IMP_PREVIEW");
          setTimeout(() => {
            if (this.getFrom) {
              this.$router.push("/net-pend/index");
            } else {
              this.$router.push("/home");
            }
          }, 200);
        })
        .catch(() => {});
    },
    showTips() {
      if (!this.count.normal_count && !this.count.abnormal_count) {
        this.isNull = true;
        return;
      }
      this.tips = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
.abnormal {
  padding-bottom: 40px;

  section {
    background: #ffffff;
    padding: 10px 20px 0;
    border-radius: 3px;

    .title {
      margin-bottom: 10px;
      color: #595959;
      font-size:14px;

      span {
        color: red;
      }
    }

    .pages {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      margin-bottom: 10px;

      .pages_right {
        display: flex;
      }
    }

    .table {
      .operation {
        a {
          padding: 0 5px;
          color: #1C8BF6;
        }
      }

      td {
        padding: 11px 10px;
      }

      .error {
        color: red;
      }

      .noBody {
        min-height: 40vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 16px;

        img {
          width: 255px;
          height: 255px;
        }

        p {
          margin-top: 30px;
        }
      }

      .errorHint {
        font-size: 10px;
        color: red;
      }

      /deep/.el-table th>.cell {
        text-align: center;
      }

      /deep/.el-table .cell {
        text-align: center;
      }
    }
  }

  footer {
    height: 40px;
    position: fixed;
    z-index: 99;
    left: 0;
    bottom: 0;
    right: 0;

    .footer {
      height: 40px;
      line-height: 40px;
      background: #ffffff;
      text-align: center;
      box-shadow: 1px 0 7px rgba(0, 0, 0, 0.1);
      padding-left: 60px;

      .cancel {
        margin-right: 20px;
        background: #fff;
        color: #1C8BF6;
        border: 1px solid #1C8BF6;
      }

      .disabel {
        background: #c5c5c5;
        color: #e3e3e3;
      }

      >div {
        width: 1200px;
        margin: 0 auto;
        text-align: center;

        .allCheck {
          float: left;
           span{
            padding-left:10px
            b{
              padding:0 5px;
              color:#1c8bf6
            }
          }
        }
        .btn {
          justify-content: center;
          align-items: center;
         .footBtn{
            width 160px
            margin-right 10px
            padding 8px 10px
          }
        }
      }
    }
  }

  .content {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #212121;

    span {
      color: #FF0000;
    }
  }

  .piint_title, .print_content {
    text-align: center;
    font-size: 18px;
  }

  .print_content {
    margin-top: 20px;

    .qrcode {
      width: 180px;
      height: 180px;
      margin: 0 auto;
      padding-bottom: 15px;
    }
  }

  // 隐藏右上角叉号
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    display: none;
  }

  // /deep/ .el-button {
  //   padding: 15px 50px;
  //   font-size: 18px;
  //   margin-right: 15px;
  //   margin-left: 15px;
  // }

  /deep/.el-dialog--center .el-dialog__body {
    padding-bottom: 10px;
  }

  .upFile {
    position: relative;
    cursor: pointer;
    display: inline-block;

    .file {
      cursor: pointer;
      position: absolute;
      width: 100%;
      height: 100%;
      right: 0;
      opacity: 0;
      z-index: 9;
    }
  }

  .model {
    padding: 0 40px;
    font-weight: normal;

    .title {
      color: #212121;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }

    .content {
      text-align: left;
    }

    .dowbload {
      padding: 15px 0;

      a {
        border: 1px solid #1C8BF6;
        padding: 6px 15px;
        border-radius: 4px;
      }
    }

    span {
      color: #FF0000;
    }
  }

  /deep/ .el-dialog__body {
    padding: 10px 40px;
  }
}
</style>
